import module from 'app/module.js'

export class AppActivarUsuario {
  constructor ($http) {
    this.$http = $http
  }

  get (usuario_id) {
    return this.$http.get('api/activacion/usuario', {
      params:{usuario_id}
    })
  }

  post (data, token) {
    return this.$http.post('api/activacion/usuario', data, {
      params:{token}
    })
  }
}

module.service('AppActivarUsuario', AppActivarUsuario)



// WEBPACK FOOTER //
// ./src/app/services/Activacion/Usuario.js